import styles from "../../pages/suppliers/layout.module.css";
import logo from "assets/logo/logo.png";
// import avatar from "../../assets/icons/avatar.png";
import { Menu, Button } from "antd";
import config from "../../config/dashboardRoute";
import { Link, useMatch } from "@reach/router";
import { useCallback, useMemo } from "react";
import { XCircle, LogOut } from "react-feather";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { toggle, close } from "../../redux/slices/sidenav";
import useAuth from "../../hooks/useAuth";

export default function SideNav({ path }: { path?: any }) {
  const { logOut, supplier, user } = useAuth();
  const { open } = useSelector((state: RootState) => state.sidenav);
  const dispatch = useDispatch();
  const params = useMatch("*") as {
    "*": string;
    uri: string;
    _path: `${string}/*`;
  };
  const _path = useMemo(() => {
    return params?.["*"].replace(/\/.*/, "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.["*"]]);
  const getBasePath = useCallback((_path: `${string}/*`) => {
    return _path.replace(/\/\*$/, "");
  }, []);

  return (
    <div
      className={classNames([
        styles.side__nav,
        { [styles.side__nav__close]: !open },
      ])}
    >
      <div>
        <div className={styles.cancel}>
          <img
            data-testid="logo"
            src={logo}
            alt="logo"
            className={styles.logo}
          />
          <button
            data-testid="toggle-btn"
            onClick={() => {
              dispatch(toggle());
            }}
          >
            <XCircle />
          </button>
        </div>
        <div className={styles.dp}>
          <div className={styles.circle} />
          <div>
            <img
              data-testid="img"
              src={
                supplier?.businessLogo ??
                "https://materialspro-media.s3.us-west-1.amazonaws.com/user-avatar.png"
              }
              width={100}
              alt="profile"
            />
          </div>
          <p data-testid="username">{user.firstName}</p>
          <span>Supplier Admin</span>
        </div>
        <Menu
          className={styles.menu}
          onSelect={() => {
            dispatch(close());
          }}
          selectedKeys={[_path]}
          mode="inline"
        >
          {config.map(({ icon, title, path }) => {
            return (
              <Menu.Item
                className={styles.menuItem}
                key={getBasePath(path)}
                icon={icon}
                style={
                  window.location.pathname.includes(getBasePath(path))
                    ? {
                        backgroundColor: "transparent",
                        borderLeft: "3px solid #00962C",
                        opacity: 1,
                      }
                    : {
                        backgroundColor: "transparent",
                        borderLeft: "3px solid transparent",
                        opacity: 0.4,
                      }
                }
              >
                <Link onClick={() => dispatch(toggle())} to={getBasePath(path)}>
                  {title}
                </Link>
              </Menu.Item>
            );
          })}
        </Menu>
      </div>
      <div>
        <Button
          data-testid="logout-btn"
          onClick={logOut}
          type="link"
          block
          danger
          icon={<LogOut height={14} />}
          style={{ paddingLeft: 0, textAlign: "start" }}
        >
          <span style={{ marginLeft: 10 }}>Log Out</span>
        </Button>
      </div>
    </div>
  );
}
